export const CabinetConstants = {
  DocumentFields: {
    DocId: 'CB_DOCID',
    DocumentDate: 'CB_DOCDATE',
    BatchNumber: 'CB_BATCHNO',
    FileType: 'CB_FILETYPE',
    PageCount: 'CB_PAGES',
    CreatedDate: 'CB_DATE',
    Disk: 'CB_DISK',
    CabinetReferencePrefix: 'CB_CREF',
    DocumentReferencePrefix: 'CB_DREF'
  }
};
